import React, { FC, useState, useEffect } from 'react';
import './style.scss';

interface Props {
  status?: string;
  value: string;
  placeholder?: string;
  styleDef?: React.CSSProperties;
  labelStyleDef?: React.CSSProperties;
  inpStyleDef?: React.CSSProperties;
  changeEvt: (e: React.ChangeEvent<HTMLInputElement>) => void;
  confirmEvent?: () => void;
  inputRef: React.ForwardedRef<HTMLInputElement>;
  label?: string;
  labelPosition?: string;
  type?: string;
  name?: string;
}

const InputBox: FC<Props> = ({
  status = '',
  placeholder = '',
  value,
  inputRef,
  confirmEvent,
  changeEvt,
  styleDef,
  labelStyleDef,
  inpStyleDef,
  label = '',
  type = 'text',
  labelPosition = '',
  name = '',
}) => {
  // Value
  const labelWidth = styleDef?.minWidth || '80px';
  const fontSize = styleDef?.fontSize || '14px';
  // State
  const [viewStatus, setViewStatus] = useState({ status: status || '' });
  useEffect(() => {
    setViewStatus({ status: status });
  }, [status]);

  // Event
  const onKeydownEvt = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      confirmEvent !== undefined && confirmEvent();
    }
  };
  const focusEvent = (e: React.ChangeEvent<HTMLInputElement>) => {
    setViewStatus({ status: '_active' });
  };
  const focusOutEvent = (e: React.ChangeEvent<HTMLInputElement>) => {
    setViewStatus({ status: '' });
  };
  return (
    <div className={['_input_box_at', viewStatus.status, labelPosition].join(' ')}>
      {label !== '' ? (
        <div className={['_label_div', labelPosition].join(' ')} style={labelStyleDef}>
          <div className="_text">{label}</div>
        </div>
      ) : (
        ''
      )}
      <div className="_input" style={styleDef}>
        <input
          name={name}
          style={inpStyleDef}
          type={type}
          placeholder={placeholder}
          value={value}
          ref={inputRef}
          onKeyDown={e => onKeydownEvt(e)}
          onChange={e => changeEvt(e)}
          onFocus={e => focusEvent(e)}
          onBlur={e => focusOutEvent(e)}
          disabled={
            viewStatus.status === '_disable' || viewStatus.status === '_read' ? true : false
          }
        />
      </div>
    </div>
  );
};

export default InputBox;
